import { PackageDTO } from "../CategoryService";

interface PackageListProps {
    packages: PackageDTO[];
    onAddPackage: () => void;
    onEditPackage: (pkg: PackageDTO) => void;
    onDeletePackage: (packageId: number) => void;
    onViewPackage: (pkg: PackageDTO) => void;
}

const PackageList: React.FC<PackageListProps> = ({ packages, onAddPackage, onDeletePackage, onEditPackage, onViewPackage }) => {
    const isMobile = window.innerWidth <= 768;

    return (
        <div className="container package-list">
            <h2>Packages</h2>
            <button className="btn btn-primary mb-3" onClick={onAddPackage}>Add Package</button>
            <div className="list-header">
                <span>Name</span>
                <span>Category</span>
                <span>Description</span>
                <span>Price From</span>
                <span>Max Group Size</span>
     
            </div>
            <ul className="list-group">
                {packages.map((p) => (
                    <li key={p.id} className="list-group-item">
                        <div className="package-info">
                            <div className="package-field">
                                <span className="field-label">Name:</span>
                                <span><strong>{p.name}</strong></span>
                            </div>
                            <div className="package-field">
                                <span className="field-label">Category:</span>
                                <span>{p.categoryName}</span>
                            </div>
                            <div className="package-field">
                                <span className="field-label">Description:</span>
                                <span>{p.description}</span>
                            </div>
                            <div className="package-field">
                                <span className="field-label">Price From:</span>
                                <span>{p.priceFrom}</span>
                            </div>
                            <div className="package-field">
                                <span className="field-label">Max Group Size:</span>
                                <span>{p.maxGroupSize}</span>
                            </div>
                        </div>
                        {p.imageUrls && (
                            <div className="package-images">
                                {p.imageUrls
                                    .sort((a, b) => (b.isMain ? 1 : -1))
                                    .slice(0, isMobile ? 3 : p.imageUrls.length)
                                    .map((image, index) => (
                                        <div key={index} className="image-container">
                                            <img
                                                src={image.url}
                                                alt={`Package ${index + 1}`}
                                                className={`img-thumbnail ${image.isMain ? "border border-primary" : ""}`}
                                            />
                                        </div>
                                    ))}
                            </div>
                        )}
                        <div className="package-actions">
                            <button className="btn btn-sm btn-outline-primary me-2" onClick={() => onEditPackage(p)}>
                                <i className="fas fa-edit"></i> Edit
                            </button>
                            <button className="btn btn-sm btn-outline-danger me-2" onClick={() => p.id !== undefined && onDeletePackage(p.id)}>
                                <i className="fas fa-trash-alt"></i> Delete
                            </button>
                            <button className="btn btn-sm btn-outline-info" onClick={() => onViewPackage(p)}>
                                <i className="fas fa-eye"></i> View
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PackageList;